export default {
  "FACILITIES_APP_VIEW": "FACILITIES_APP_VIEW",
  "APP_COMMERCE_VIEW": "COMMERCEUSER_VIEW",
  "APP_PWA_STANDALONE_ACCESS": "COMMON_ADMIN"
} as any